/**
 * Presentation-layer mapping of canonical DB roles → 4-tier product labels.
 * The backend still stores canonical values (`super_admin`, `admin`,
 * `editor`, `customer`) for compatibility; this module surfaces the labels
 * the product spec calls for.
 */

export const ROLE_LABEL = {
  super_admin: "SysAdmin",
  admin:       "Admin",
  editor:      "Editor",
  staff:       "Editor",     // legacy alias
  field_staff: "Driver / Field Staff (No Login)",
  customer:    "Client",
};

export const ROLE_DESCRIPTION = {
  super_admin: "Full system access — DB health, environment, roles",
  admin:       "Operational lead — Bookings, Fleet, Pricing, Vouchers",
  editor:      "Bookings & fleet status only",
  field_staff: "Physical driver/delivery staff — no admin login, name-only profile",
  customer:    "Customer — view own bookings",
};

export const ROLE_TINT = {
  super_admin: "bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-300 border-red-200 dark:border-red-900",
  admin:       "bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-300 border-violet-200 dark:border-violet-900",
  editor:      "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300 border-sky-200 dark:border-sky-900",
  staff:       "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300 border-sky-200 dark:border-sky-900",
  field_staff: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300 border-amber-200 dark:border-amber-900",
  customer:    "bg-neutral-200 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-200 border-neutral-300 dark:border-neutral-700",
};

// Roles a SysAdmin is allowed to assign (SysAdmin is not user-assignable
// on the frontend; it must be seeded server-side).
export const ASSIGNABLE_ROLES = ["admin", "editor", "customer"];

export function roleLabel(role) {
  return ROLE_LABEL[role] || (role ? role.replace(/_/g, " ") : "—");
}

export function roleTintClass(role) {
  return ROLE_TINT[role] || ROLE_TINT.customer;
}

export function isSysAdmin(user) {
  return user?.role === "super_admin";
}
export function isAdmin(user) {
  return user?.role === "admin" || user?.role === "super_admin";
}
export function isEditor(user) {
  return ["editor", "staff", "admin", "super_admin"].includes(user?.role);
}
export function isClient(user) {
  return user?.role === "customer";
}
